import { useTranslation } from 'react-i18next';
import AnimateSection from '@/components/base/AnimateSection';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20elegant%20abstract%20background%20with%20warm%20rose%20gold%20and%20cream%20gradient%2C%20subtle%20texture%2C%20luxurious%20minimalist%20style%2C%20clean%20smooth%20surface%2C%20romantic%20aesthetic%2C%20high%20end%20editorial%20backdrop%2C%20soft%20diffused%20lighting&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-800/70"></div>
      </div>

      <AnimateSection>
        <div className="relative z-10 max-w-2xl mx-auto text-center px-4">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            {t('home.ctaTitle')}
          </h2>
          <p className="text-sm md:text-base text-background-200/90 mb-8">
            {t('home.ctaDesc')}
          </p>
          <button
            onClick={() => {
              const msg = '按下 Ctrl+D (Mac: ⌘+D) 即可收藏本页';
              alert(msg);
            }}
            className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-700 rounded-full text-sm font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-bookmark-line"></i>
            {t('home.ctaButton')}
          </button>
        </div>
      </AnimateSection>
    </section>
  );
}